import { INITIAL_STATE } from "./InitialState";
import { createReducer } from "reduxsauce";
import { UserTypes } from "./Actions";

export const setHeaderTitleReducer = (state, { headerTitle }) => ({
  ...state,
  headerTitle: headerTitle,
});

export const setShowHideLoaderReducer = (state, { status }) => ({
  ...state,
  loading: status,
});

export const userLoginSuccessReducer = (state, { userResponse }) => ({
  ...state,
  user: userResponse,
});

export const userTokenReducer = (state, { token }) => ({
  ...state,
  token: token,
});

export const getAssignmentForStudentSuccessReducer = (
  state,
  { assignmentData }
) => ({
  ...state,
  assignmentData: assignmentData,
});

export const saveAssignmentSummaryForStudentSuccessReducer = (
  state,
  { assignmentDataSummary }
) => ({
  ...state,
  assignmentDataSummary: assignmentDataSummary,
});

export const saveLessonUnitDetailsForStudentSuccessReducer = (
  state,
  { lessonUnitDetails }
) => ({
  ...state,
  lessonUnitDetails: lessonUnitDetails,
});

export const saveCompletedLessonUnitDetailsForStudentSuccessReducer = (
  state,
  { completedlessonUnitDetails }
) => ({
  ...state,
  completedlessonUnitDetails: completedlessonUnitDetails,
});

export const setCurrentActivityDetailsReducer = (
  state,
  { currentActivity }
) => ({
  ...state,
  currentActivity: currentActivity,
});

export const setCurrentContainedActivityDetailsReducer = (
  state,
  { containedActivity }
) => ({
  ...state,
  containedActivity: containedActivity,
});

export const setCurrentLessonUnitDistIdReducer = (
  state,
  { currentLessonUnitDistId }
) => ({
  ...state,
  currentLessonUnitDistId: currentLessonUnitDistId,
});

export const setWorkJsonReducer = (state, { WorkJson }) => ({
  ...state,
  WorkJson: WorkJson,
});

export const setContainedWorkJsonReducer = (state, { containedWorkJson }) => ({
  ...state,
  containedWorkJson: containedWorkJson,
});

export const saveExerciseListReducer = (state, { exerciseList }) => ({
  ...state,
  exerciseList: exerciseList,
});

export const savePreviousExerciseReducer = (state, { exerciseList }) => ({
  ...state,
  previousExerciseList: exerciseList,
});

export const saveUnitName = (state, { currentUnitName }) => ({
  ...state,
  unitName: currentUnitName,
});

export const saveSubjectID = (state, { currentSubjectID }) => ({
  ...state,
  SubjectID: currentSubjectID,
});

export const saveCourseId = (state, { currentCourseId }) => ({
  ...state,
  currentCourseId: currentCourseId,
});

export const changeLoggedOutStatusReducer = (state) => ({
  ...state,
  isLoggedIn: false,
  user: {},
});

export const setCurrentLessonNameReducer = (state, { currentLessonName }) => ({
  ...state,
  currentLessonName: currentLessonName,
});

export const saveFromPending = (state, { fromPending }) => ({
  ...state,
  fromPending: fromPending,
});

export const getCourseSummaryAnalyticsReportSuccessReducer = (
  state,
  { CourseAnalytics }
) => ({
  ...state,
  CourseAnalytics: CourseAnalytics,
});

export const getLessonPodSummaryAnalyticsReportSuccessReducer = (
  state,
  { StudentLessonpodAnalytics }
) => ({
  ...state,
  StudentLessonpodAnalytics: StudentLessonpodAnalytics,
});

export const getLessonPodActivityAnalyticsReportSuccessReducer = (
  state,
  { StudentActivityAnalytics }
) => ({
  ...state,
  StudentActivityAnalytics: StudentActivityAnalytics,
});

export const saveFromAnalytics = (state, { fromAnalytics }) => ({
  ...state,
  fromAnalytics: fromAnalytics,
});
export const saveFromCourse = (state, { fromCourse }) => ({
  ...state,
  fromCourse: fromCourse,
});

export const showOrHideToaster = (
  state,
  { showToastModal, toastMessageText, toastType }
) => ({
  ...state,
  showToastModal: showToastModal,
  toastMessageText: toastMessageText,
  toastType: toastType,
});

export const onHeaderItemSelected = (state, { headerItemSelected }) => ({
  ...state,
  headerItemSelected: headerItemSelected,
});
export const setNavigationIndex = (state, { navigationIndex }) => ({
  ...state,
  navigationIndex: navigationIndex,
});
export const saveCourseName = (state, { currentCourseName }) => ({
  ...state,
  currentCourseName: currentCourseName,
});

export const hardResetRandomActivity = (state, { hardResetRandom }) => ({
  ...state,
  hardResetRandom: hardResetRandom,
});
export const saveSelectedClass = (state, { selectedClass }) => ({
  ...state,
  selectedClass: selectedClass,
});
export const saveSelectedChapter = (state, { selectedChapter }) => ({
  ...state,
  selectedChapter: selectedChapter,
});
export const saveSelectedFolder = (state, { selectedFolder }) => ({
  ...state,
  selectedFolder: selectedFolder,
});
export const saveCurrentOSName = (state, { currentOSName }) => ({
  ...state,
  currentOSName: currentOSName,
});
export const saveWalkthroughStatus = (state, { walkthroughStatus }) => ({
  ...state,
  walkthroughStatus: walkthroughStatus,
});

export const saveMuteStatus = (state, { muteStatus, muteClicked }) => ({
  ...state,
  muteStatus: muteStatus,
  muteClicked: muteClicked,
});
export const saveSpeechApi = (state, { speechApi }) => ({
  ...state,
  speechApi: speechApi,
});

export const reducer = createReducer(INITIAL_STATE, {
  [UserTypes.USER_LOGIN_SUCCESS]: userLoginSuccessReducer,
  [UserTypes.USER_TOKEN]: userTokenReducer,
  [UserTypes.GET_ASSIGNMENT_DATA_FOR_STUDENT_SUCCESS]:
    getAssignmentForStudentSuccessReducer,
  [UserTypes.SAVE_ASSIGNMENT_SUMMARY_FOR_STUDENT_SUCCESS]:
    saveAssignmentSummaryForStudentSuccessReducer,
  [UserTypes.SAVE_LESSON_UNIT_DETAILS_FOR_STUDENT]:
    saveLessonUnitDetailsForStudentSuccessReducer,
  [UserTypes.SAVE_COMPLETED_LESSON_UNIT_DETAILS_FOR_STUDENT]:
    saveCompletedLessonUnitDetailsForStudentSuccessReducer,
  [UserTypes.SET_CURRENT_ACTIVITY_DETAILS]: setCurrentActivityDetailsReducer,
  [UserTypes.SET_CURRENT_CONTAINED_ACTIVITY_DETAILS]:
    setCurrentContainedActivityDetailsReducer,
  [UserTypes.SET_CURRENT_LESSON_UNIT_DIST_ID]:
    setCurrentLessonUnitDistIdReducer,
  [UserTypes.SET_WORK_JSON]: setWorkJsonReducer,
  [UserTypes.SET_CONTAINED_WORK_JSON]: setContainedWorkJsonReducer,
  [UserTypes.SAVE_EXERCISE_LIST_IN_STATE]: saveExerciseListReducer,
  [UserTypes.SAVE_PREVIOUS_EXERCISE_IN_STATE]: savePreviousExerciseReducer,
  [UserTypes.SET_HEADER_TITLE]: setHeaderTitleReducer,
  [UserTypes.SET_SHOW_HIDE_LOADER]: setShowHideLoaderReducer,
  [UserTypes.SAVE_UNIT_NAME]: saveUnitName,
  [UserTypes.SAVE_SUBJECT_ID]: saveSubjectID,
  [UserTypes.SAVE_COURSE_ID]: saveCourseId,
  [UserTypes.CHANGE_LOGGED_OUT_STATUS_IN_STATE]: changeLoggedOutStatusReducer,
  [UserTypes.SET_CURRENT_LESSON_NAME]: setCurrentLessonNameReducer,
  [UserTypes.SAVE_FROM_PENDING]: saveFromPending,
  [UserTypes.GET_COURSE_SUMMARY_ANALYTICS_REPORT_SUCCESS]:
    getCourseSummaryAnalyticsReportSuccessReducer,
  [UserTypes.GET_LESSON_POD_SUMMARY_ANALYTICS_REPORT_SUCCESS]:
    getLessonPodSummaryAnalyticsReportSuccessReducer,
  [UserTypes.GET_LESSON_POD_ACTIVITY_ANALYTICS_REPORT_SUCCESS]:
    getLessonPodActivityAnalyticsReportSuccessReducer,
  [UserTypes.SAVE_FROM_ANALYTICS]: saveFromAnalytics,
  [UserTypes.SAVE_FROM_COURSE]: saveFromCourse,
  [UserTypes.SHOW_OR_HIDE_TOASTER]: showOrHideToaster,
  [UserTypes.ON_HEADER_ITEM_SELECTED]: onHeaderItemSelected,
  [UserTypes.SET_NAVIGATION_INDEX]: setNavigationIndex,
  [UserTypes.SAVE_COURSE_NAME]: saveCourseName,
  [UserTypes.HARD_RESET_RANDOM_ACTIVITY]: hardResetRandomActivity,
  [UserTypes.SAVE_SELECTED_CLASS]: saveSelectedClass,
  [UserTypes.SAVE_SELECTED_CHAPTER]: saveSelectedChapter,
  [UserTypes.SAVE_SELECTED_FOLDER]: saveSelectedFolder,
  [UserTypes.SAVE_CURRENT_OS_NAME]: saveCurrentOSName,
  [UserTypes.SAVE_WALKTHROUGH_STATUS]: saveWalkthroughStatus,
  [UserTypes.SAVE_MUTE_STATUS]: saveMuteStatus,
  [UserTypes.SAVE_SPEECH_API]: saveSpeechApi,
});
